import React from 'react'

export default function Input({type='text',placeholder,required=false,value,setValue,error=null,viewMode,pattern,number=false,disabled=false,ref=null,padding=true,min=null,max='',date=false,defaultValue=null}) {

    const onPress = (e)=>
    {
        const re = /^[0-9]*\.?[0-9]*$/;

        if(number === true)
        {
          if (e.target.value === '' || re.test(e.target.value)) {
            return true;
          }
          else return false;
        }
    }
    const onChange = (e)=>
    {
        const re = /^[0-9]*\.?[0-9]*$/;

        if(number === true)
        {
          if (e.target.value === '' || re.test(e.target.value)) {
            setValue(e.target.value)
          }
        }
        else setValue(e.target.value)
    }
    
  return (
    <div className={`relative ${padding ? 'pb-3' : ''}`}>
    {viewMode ? type === 'password' ? <input disabled={true} defaultValue={defaultValue} className='bg-white font-medium leading-normal' type={'password'}  value={'sampletext'} required={false}/> : <p className={`text-[13px] md:text-sm text-black font-medium leading-normal ${type!=='email' ? 'capitalize':''}`}>{value}</p> : <input min={min} max={max} disabled={disabled} ref={ref} type={type}  pattern={pattern}  value={value} className={`${error ? 'error-input' : 'text-input font-medium leading-normal'}`} 
    placeholder={placeholder} required={required} onChange={onChange} onKeyDown={onPress}/>}
    {error ? <div className="w-full absolute left-0 bottom-0 flex items-center pointer-events-none overflow-hidden h-4">
                                <div className='text-center'>
                            <p className='text-red-600 h-[20px] text-[12px] tracking-tight font-medium'>{error}</p>
                                    </div>
                        </div> : null}
    </div>
  )
}
